import React, {Component} from 'react';

class Loader extends Component {
    render()
    {
        return (
            <div className="loader">
                <img src="/system_images/loader.gif" />
            </div>
        );
    }

}

export default Loader;